/**
 * Encode/decode "back" navigation targets for product detail and validate in-app paths.
 */

var ALLOWED_PATHS = ['/products', '/issues', '/alerts', '/stock', '/home', '/all-alerts', '/old-dashboard']

export function isSafeAppInternalPath (fullPath) {
  if (!fullPath || typeof fullPath !== 'string' || fullPath.charAt(0) !== '/') return false
  if (fullPath.indexOf('/../') >= 0 || fullPath.indexOf('/./') >= 0) return false
  var q = fullPath.indexOf('?')
  var hash = fullPath.indexOf('#')
  var end = q >= 0 ? q : (hash >= 0 ? hash : fullPath.length)
  var path = fullPath.slice(0, end)
  if (!path || path.indexOf('//') === 0) return false
  for (var i = 0; i < ALLOWED_PATHS.length; i++) {
    if (path === ALLOWED_PATHS[i]) return true
  }
  return false
}

export function encodeBackQuery (fullPath) {
  if (!isSafeAppInternalPath(fullPath)) return null
  try {
    return encodeURIComponent(fullPath)
  } catch (e) {
    return null
  }
}

export function decodeBackQuery (encoded) {
  if (encoded == null || encoded === '') return null
  try {
    var decoded = decodeURIComponent(typeof encoded === 'string' ? encoded : String(encoded))
    if (!isSafeAppInternalPath(decoded)) return null
    return decoded
  } catch (e) {
    return null
  }
}

export function buildProductDetailsQuery (id, currentFullPath) {
  var q = { id: String(id).replace(/^PROD-/i, '') }
  var enc = encodeBackQuery(currentFullPath)
  if (enc) q.back = enc
  return q
}

export function backLinkLabelForPath (fullPath) {
  if (!fullPath) return 'Back'
  var path = fullPath.split('?')[0]
  if (path === '/products') return 'Back to Products'
  if (path === '/issues' || path === '/alerts') return 'Back to Alerts'
  if (path === '/stock') return 'Back to Stock'
  if (path === '/home' || path === '/old-dashboard') return 'Back to Dashboard'
  if (path === '/all-alerts') return 'Back to All Alerts'
  return 'Back'
}



// WEBPACK FOOTER //
// ./src/utils/listViewUrlSync.js